/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description This utility functions formats a given number to comma separated string using en-US standards.
 * @param value This is the number which will be formatted.
 */

export const formatNumber = (value) => {
  if (value === undefined || value === null || value === '') {
    return '0.00'
  }

  const number = Number(value)
  if (isNaN(number)) {
    return '0.00'
  }

  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * @description Formats a number as a comma separated whole number, rounding off the decimals.
 * @param value This is the number which will be formatted.
 */

export const formatWholeNumber = (value) => {
  const number = Number(value)
  if (value === '' || !Number.isFinite(number)) {
    return '0'
  }

  // Rounds half away from zero to match the backend's Float#round
  const rounded = Math.sign(number) * Math.round(Math.abs(number))

  // Normalises -0 so small negatives don't render as "-0"
  return (rounded === 0 ? 0 : rounded).toLocaleString("en-US")
}
